(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-announcement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var SEL = '[data-sv-announcement]';
    var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    function onMq(mq, fn) {
      if (!mq) return function () {};
      if (mq.addEventListener) {
        mq.addEventListener('change', fn);
        return function () { mq.removeEventListener('change', fn); };
      }
      if (mq.addListener) {
        mq.addListener(fn);
        return function () { mq.removeListener(fn); };
      }
      return function () {};
    }

    function create(root) {
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-sv-ann-slide]'));
      var track = root.querySelector('[data-sv-ann-track]');
      var api = { destroy: function () {}, select: function () {}, deselect: function () {} };
      if (slides.length < 2 || !track) return api;

      var wantsAuto = root.getAttribute('data-autoplay') === 'true';
      var interval = Math.max(2500, parseInt(root.getAttribute('data-interval'), 10) || 5000);
      var index = 0;
      var timer = null;
      var holds = {};
      var touchX = null;
      var touchY = null;

      function reduced() {
        return !!(mqReduce && mqReduce.matches);
      }

      function isHeld() {
        for (var key in holds) {
          if (holds[key]) return true;
        }
        return false;
      }

      function rotating() {
        return wantsAuto && !reduced() && !isHeld() && !document.hidden;
      }

      function syncLive() {
        track.setAttribute('aria-live', rotating() ? 'off' : 'polite');
      }

      function show(next) {
        var count = slides.length;
        next = ((next % count) + count) % count;
        if (next === index) return;

        var prev = slides[index];
        var cur = slides[next];

        prev.classList.remove('is-active');
        prev.classList.add('is-out');
        prev.setAttribute('aria-hidden', 'true');
        clearTimeout(prev._svOut);
        prev._svOut = setTimeout(function () {
          prev.classList.remove('is-out');
        }, 720);

        clearTimeout(cur._svOut);
        cur.classList.remove('is-out');
        cur.classList.add('is-active');
        cur.removeAttribute('aria-hidden');
        index = next;
      }

      function schedule() {
        clearTimeout(timer);
        timer = null;
        syncLive();
        if (!rotating()) return;
        timer = setTimeout(function () {
          show(index + 1);
          schedule();
        }, interval);
      }

      function hold(key, on) {
        holds[key] = !!on;
        schedule();
      }

      var prevBtn = root.querySelector('[data-sv-ann-prev]');
      var nextBtn = root.querySelector('[data-sv-ann-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { show(index - 1); schedule(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { show(index + 1); schedule(); });

      /* Hover pause for real pointers only: a tap fires a compat mouseenter with no
         mouseleave, which would freeze rotation on phones for the rest of the visit. */
      if (window.PointerEvent) {
        root.addEventListener('pointerenter', function (event) {
          if (event.pointerType === 'mouse' || event.pointerType === 'pen') hold('hover', true);
        });
        root.addEventListener('pointerleave', function () { hold('hover', false); });
      } else {
        root.addEventListener('mouseenter', function () { hold('hover', true); });
        root.addEventListener('mouseleave', function () { hold('hover', false); });
      }
      root.addEventListener('focusin', function () { hold('focus', true); });
      root.addEventListener('focusout', function (event) {
        if (!event.relatedTarget || !root.contains(event.relatedTarget)) hold('focus', false);
      });

      /* Swipe on touch screens, where the arrows are hidden. */
      track.addEventListener('touchstart', function (event) {
        var t = event.touches && event.touches[0];
        if (!t) return;
        touchX = t.clientX;
        touchY = t.clientY;
        hold('touch', true);
      }, { passive: true });

      track.addEventListener('touchend', function (event) {
        var t = event.changedTouches && event.changedTouches[0];
        if (t && touchX !== null) {
          var dx = t.clientX - touchX;
          var dy = t.clientY - touchY;
          if (Math.abs(dx) > 36 && Math.abs(dx) > Math.abs(dy)) show(dx < 0 ? index + 1 : index - 1);
        }
        touchX = null;
        touchY = null;
        hold('touch', false);
      }, { passive: true });

      track.addEventListener('touchcancel', function () {
        touchX = null;
        touchY = null;
        hold('touch', false);
      }, { passive: true });

      function onVisibility() { schedule(); }
      document.addEventListener('visibilitychange', onVisibility);
      var offMq = onMq(mqReduce, schedule);

      schedule();

      api.destroy = function () {
        clearTimeout(timer);
        document.removeEventListener('visibilitychange', onVisibility);
        offMq();
      };

      api.select = function (el) {
        var i = slides.indexOf(el);
        if (i > -1) show(i);
        hold('editor', true);
      };

      api.deselect = function () {
        hold('editor', false);
      };

      return api;
    }

    function init(root) {
      if (!root || root._svAnn) return;
      root._svAnn = create(root);
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll(SEL);
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    function rootFrom(event) {
      var t = event.target;
      if (!t || !t.closest) return null;
      return t.closest(SEL);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });

    document.addEventListener('shopify:section:unload', function (event) {
      var roots = event.target.querySelectorAll(SEL);
      for (var i = 0; i < roots.length; i++) {
        if (roots[i]._svAnn) roots[i]._svAnn.destroy();
      }
    });

    document.addEventListener('shopify:block:select', function (event) {
      var root = rootFrom(event);
      if (root && root._svAnn) root._svAnn.select(event.target);
    });

    document.addEventListener('shopify:block:deselect', function (event) {
      var root = rootFrom(event);
      if (root && root._svAnn) root._svAnn.deselect();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-faq"] && !Shopify.designMode) return;
  try {
    
  /* STRYVE FAQ — smooth accordion on native <details>. Without JS the
     disclosure still works (and stays exclusive via the `name` attribute). */
  (function () {
    'use strict';

    var SEL = '[data-sv-faq]';
    var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    function reduced() {
      return !!(mqReduce && mqReduce.matches);
    }

    function stopAnim(d) {
      if (d._svAnim) {
        d._svAnim.cancel();
        d._svAnim = null;
      }
      d.classList.remove('is-animating', 'is-closing');
    }

    function setOpen(d, open, instant) {
      var panel = d.querySelector('[data-sv-faq-panel]');
      if (instant || !panel || reduced() || typeof panel.animate !== 'function') {
        stopAnim(d);
        d.open = open;
        return;
      }

      var from = d.open ? panel.getBoundingClientRect().height : 0;
      stopAnim(d);
      d.classList.add('is-animating');

      var to = 0;
      if (open) {
        d.open = true;
        to = panel.scrollHeight;
      } else {
        d.classList.add('is-closing');
      }

      /* fill: forwards holds the end frame until [open] is committed, so a closing
         panel never flashes back to full height for a frame. */
      var anim = panel.animate(
        [
          { height: from + 'px', opacity: from > 0 ? 1 : 0 },
          { height: to + 'px', opacity: open ? 1 : 0 }
        ],
        { duration: 380, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)', fill: 'forwards' }
      );
      d._svAnim = anim;
      anim.onfinish = function () {
        if (d._svAnim !== anim) return;
        d._svAnim = null;
        if (!open) d.open = false;
        d.classList.remove('is-animating', 'is-closing');
        anim.cancel();
      };
    }

    function isOpen(d) {
      return d.open && !d.classList.contains('is-closing');
    }

    function items(root) {
      return Array.prototype.slice.call(root.querySelectorAll('[data-sv-faq-item]'));
    }

    function openOnly(root, target, instant) {
      var single = root.getAttribute('data-single') === 'true';
      if (single) {
        items(root).forEach(function (d) {
          if (d !== target && isOpen(d)) setOpen(d, false, instant);
        });
      }
      setOpen(target, true, instant);
    }

    function init(root) {
      if (!root || root._svFaq) return;
      root._svFaq = true;

      /* Exclusivity moves to script so the closing panel can animate too
         (a shared `name` would snap it shut the moment another opens). */
      items(root).forEach(function (d) {
        d.removeAttribute('name');
      });

      root.addEventListener('click', function (event) {
        var t = event.target;
        if (!t || !t.closest) return;
        var sum = t.closest('summary');
        if (!sum || !root.contains(sum)) return;
        var d = sum.parentElement;
        if (!d || !d.hasAttribute('data-sv-faq-item')) return;
        event.preventDefault();
        if (isOpen(d)) setOpen(d, false);
        else openOnly(root, d);
      });

      /* Opens that bypass the click (find-in-page, #fragment, editor) keep the
         one-at-a-time rule. `toggle` doesn't bubble, so listen in the capture phase. */
      root.addEventListener(
        'toggle',
        function (event) {
          var d = event.target;
          if (!d || !d.hasAttribute || !d.hasAttribute('data-sv-faq-item') || !isOpen(d)) return;
          if (root.getAttribute('data-single') !== 'true') return;
          items(root).forEach(function (other) {
            if (other !== d && isOpen(other)) setOpen(other, false, true);
          });
        },
        true
      );
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll(SEL);
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:block:select', function (event) {
      var t = event.target;
      if (!t || !t.closest || !t.hasAttribute('data-sv-faq-item')) return;
      var root = t.closest(SEL);
      if (root) openOnly(root, t, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var SEL = '[data-sv-footer]';
    var mqDesk = window.matchMedia ? window.matchMedia('(min-width: 750px)') : null;
    var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    function isDesk() {
      return !!(mqDesk && mqDesk.matches);
    }

    function reduced() {
      return !!(mqReduce && mqReduce.matches);
    }

    function stopAnim(d) {
      if (d._svAnim) {
        d._svAnim.cancel();
        d._svAnim = null;
      }
      d.classList.remove('is-animating', 'is-closing');
    }

    /* Desktop: every column open and inert; mobile: collapsed accordions.
       Runs on init and on breakpoint changes only (markup ships with [open]). */
    function syncAcc(root) {
      var desk = isDesk();
      var list = root.querySelectorAll('[data-sv-acc]');
      for (var i = 0; i < list.length; i++) {
        var d = list[i];
        var sum = d.querySelector('summary');
        stopAnim(d);
        d.open = desk;
        if (!sum) continue;
        if (desk) sum.setAttribute('tabindex', '-1');
        else sum.removeAttribute('tabindex');
      }
    }

    function toggle(d, open) {
      var panel = d.querySelector('[data-sv-acc-panel]');
      if (!panel || reduced() || typeof panel.animate !== 'function') {
        stopAnim(d);
        d.open = open;
        return;
      }

      var from = d.open ? panel.getBoundingClientRect().height : 0;
      if (d._svAnim) {
        d._svAnim.cancel();
        d._svAnim = null;
      }

      d.classList.add('is-animating');
      var to = 0;
      if (open) {
        d.classList.remove('is-closing');
        d.open = true;
        to = panel.scrollHeight;
      } else {
        d.classList.add('is-closing');
      }

      /* fill: forwards holds the end frame until the <details> state is committed, so a
         closing panel never flashes back to full height for a frame before [open] drops. */
      var anim = panel.animate(
        [
          { height: from + 'px', opacity: from > 0 ? 1 : 0 },
          { height: to + 'px', opacity: open ? 1 : 0 }
        ],
        { duration: 420, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)', fill: 'forwards' }
      );
      d._svAnim = anim;
      anim.onfinish = function () {
        if (d._svAnim !== anim) return;
        d._svAnim = null;
        if (!open) d.open = false;
        d.classList.remove('is-animating', 'is-closing');
        anim.cancel();
      };
    }

    function scrollToTop(target, behavior) {
      try {
        target.scrollTo({ top: 0, behavior: behavior });
      } catch (err) {
        if (target === window) window.scrollTo(0, 0);
        else target.scrollTop = 0;
      }
    }

    /* Horizon scrolls .page-wrapper at >= 990px and the window below that:
       scroll whichever container is actually scrolled. */
    function backToTop(btn) {
      var behavior = reduced() ? 'auto' : 'smooth';
      var targets = [];
      var el = btn.parentElement;
      while (el && el !== document.body && el !== document.documentElement) {
        if (el.scrollTop > 0) targets.push(el);
        el = el.parentElement;
      }
      var wrapper = document.querySelector('.page-wrapper');
      if (wrapper && wrapper.scrollTop > 0 && targets.indexOf(wrapper) === -1) targets.push(wrapper);
      var se = document.scrollingElement || document.documentElement;
      var winY = window.pageYOffset || (se && se.scrollTop) || 0;
      if (winY > 0 || !targets.length) targets.push(window);

      for (var i = 0; i < targets.length; i++) scrollToTop(targets[i], behavior);

      var main = document.getElementById('MainContent') || document.querySelector('main');
      if (main) {
        if (!main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1');
        try {
          main.focus({ preventScroll: true });
        } catch (err) {}
      }
    }

    function init(root) {
      if (!root || root._svFooter) return;
      root._svFooter = true;

      syncAcc(root);

      root.addEventListener('click', function (event) {
        var t = event.target;
        if (!t || !t.closest) return;

        var top = t.closest('[data-sv-to-top]');
        if (top && root.contains(top)) {
          backToTop(top);
          return;
        }

        var sum = t.closest('summary');
        if (!sum) return;
        var d = sum.parentElement;
        if (!d || !d.hasAttribute('data-sv-acc') || !root.contains(d)) return;
        event.preventDefault();
        if (isDesk()) return;
        toggle(d, !d.open || d.classList.contains('is-closing'));
      });
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll(SEL);
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    function onBreakpoint() {
      var roots = document.querySelectorAll(SEL);
      for (var i = 0; i < roots.length; i++) syncAcc(roots[i]);
    }

    if (mqDesk) {
      if (mqDesk.addEventListener) mqDesk.addEventListener('change', onBreakpoint);
      else if (mqDesk.addListener) mqDesk.addListener(onBreakpoint);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });

    document.addEventListener('shopify:block:select', function (event) {
      var t = event.target;
      if (!t || !t.closest || !t.closest(SEL)) return;
      if (t.hasAttribute('data-sv-acc') && !isDesk()) {
        stopAnim(t);
        t.open = true;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    function prefersReduced() {
      return !!(mq && mq.matches);
    }

    function listen(list, fn, add) {
      if (!list) return;
      if (add) {
        if (list.addEventListener) list.addEventListener('change', fn);
        else if (list.addListener) list.addListener(fn);
      } else if (list.removeEventListener) {
        list.removeEventListener('change', fn);
      } else if (list.removeListener) {
        list.removeListener(fn);
      }
    }

    function init(root) {
      if (!root || root.svHero) return;
      var video = root.querySelector('.sv-hero__video video');
      if (!video) return;

      var btn = root.querySelector('[data-sv-hero-toggle]');
      var want = !prefersReduced();
      var visible = true;
      var io = null;

      function reflect() {
        var paused = video.paused;
        root.classList.toggle('is-paused', paused);
        if (btn) btn.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video');
      }

      function sync() {
        if (want && visible) {
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(reflect);
        } else if (!video.paused) {
          video.pause();
        }
        reflect();
      }

      function onToggle() {
        want = video.paused;
        if (want) root.classList.add('is-user-play');
        sync();
      }

      function onMotion() {
        want = !prefersReduced();
        if (!want) root.classList.remove('is-user-play');
        sync();
      }

      if (btn) btn.addEventListener('click', onToggle);
      video.addEventListener('play', reflect);
      video.addEventListener('pause', reflect);
      listen(mq, onMotion, true);

      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver(function (entries) {
          visible = entries[entries.length - 1].isIntersecting;
          sync();
        });
        io.observe(root);
      }

      root.svHero = {
        destroy: function () {
          if (io) io.disconnect();
          listen(mq, onMotion, false);
          root.svHero = null;
        }
      };

      sync();
    }

    function scan(scope) {
      var roots = (scope || document).querySelectorAll('[data-sv-hero]');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scan(); });
    } else {
      scan();
    }

    document.addEventListener('shopify:section:load', function (e) {
      scan(e.target);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var roots = e.target.querySelectorAll('[data-sv-hero]');
      for (var i = 0; i < roots.length; i++) {
        if (roots[i].svHero) roots[i].svHero.destroy();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-related"] && !Shopify.designMode) return;
  try {
    
  /* STRYVE "Complete the kit": fetches Shopify product recommendations through the
     Section Rendering API after the page settles, swaps the list items in, and
     upgrades single-variant quick add to Stryve.cart.add (plain form POST otherwise). */
  (function () {
    'use strict';

    var SEL = '[data-sv-related]';

    function designMode() {
      return !!(window.Shopify && window.Shopify.designMode);
    }

    function revealIn(scope) {
      var S = window.Stryve;
      if (S && typeof S.revealScan === 'function') {
        S.revealScan();
        return;
      }
      var els = scope.querySelectorAll('.sv-reveal');
      for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
    }

    function collect(src, pid, limit) {
      var out = { real: [], ph: [] };
      if (!src) return out;
      var kids = src.children;
      for (var i = 0; i < kids.length; i++) {
        var li = kids[i];
        var id = li.getAttribute('data-sv-pid');
        if (id) {
          if (id === pid) continue;
          if (out.real.length < limit) out.real.push(li);
        } else if (li.hasAttribute('data-sv-ph')) {
          if (out.ph.length < limit) out.ph.push(li);
        }
      }
      return out;
    }

    function fill(list, nodes, cols) {
      var frag = document.createDocumentFragment();
      for (var i = 0; i < nodes.length; i++) {
        var li = document.importNode(nodes[i], true);
        li.classList.remove('is-in');
        li.style.setProperty('--sv-delay', (i % cols) * 80 + 'ms');
        frag.appendChild(li);
      }
      while (list.firstChild) list.removeChild(list.firstChild);
      list.appendChild(frag);
    }

    function apply(root, html) {
      var list = root.querySelector('[data-sv-related-list]');
      if (!list) return;

      var pid = root.getAttribute('data-product-id') || '';
      var limit = parseInt(root.getAttribute('data-limit'), 10) || 4;
      var cols = parseInt(root.getAttribute('data-cols'), 10) || 4;

      var src = null;
      if (html && typeof DOMParser === 'function') {
        try {
          src = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-sv-related-list]');
        } catch (err) {
          src = null;
        }
      }

      var got = collect(src, pid, limit);
      list.removeAttribute('aria-busy');

      if (got.real.length) {
        fill(list, got.real, cols);
        root.setAttribute('data-state', 'ready');
      } else if (list.querySelector('[data-sv-pid]')) {
        root.setAttribute('data-state', 'fallback');
      } else if (designMode()) {
        if (got.ph.length) fill(list, got.ph, cols);
        root.setAttribute('data-state', 'placeholder');
      } else {
        root.hidden = true;
        root.setAttribute('data-state', 'empty');
        return;
      }
      revealIn(list);
    }

    function load(root) {
      if (root._svLoaded) return;
      root._svLoaded = true;

      var url = root.getAttribute('data-url');
      if (!url || typeof window.fetch !== 'function') {
        apply(root, '');
        return;
      }

      window
        .fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (res) {
          return res.ok ? res.text() : '';
        })
        .then(function (html) {
          if (root.isConnected) apply(root, html);
        })
        .catch(function () {
          if (root.isConnected) apply(root, '');
        });
    }

    /* After the page settles: the rail sits far below the buy box, so this never
       competes with above-the-fold work but still lands before a shopper scrolls there. */
    function schedule(root) {
      function go() {
        if (typeof window.requestIdleCallback === 'function') {
          window.requestIdleCallback(function () { load(root); }, { timeout: 2000 });
        } else {
          window.setTimeout(function () { load(root); }, 300);
        }
      }
      if (document.readyState === 'complete') go();
      else window.addEventListener('load', go, { once: true });
    }

    /* ---------------- quick add ---------------- */
    function announce(root, text) {
      var live = root.querySelector('[data-sv-related-live]');
      if (!live) return;
      live.textContent = '';
      window.setTimeout(function () { live.textContent = text; }, 60);
    }

    function onSubmit(root, event) {
      var form = event.target;
      if (!form || !form.hasAttribute || !form.hasAttribute('data-sv-related-add')) return;

      var S = window.Stryve;
      if (!S || !S.cart || typeof S.cart.add !== 'function') return; /* native POST to /cart/add */

      event.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var label = form.querySelector('[data-sv-label]');
      var msg = form.querySelector('[data-sv-msg]');
      var input = form.querySelector('input[name="id"]');
      if (!btn || !input || btn.getAttribute('aria-disabled') === 'true') return;

      var id = parseInt(input.value, 10);
      if (!id) return;

      if (form._svTimer) window.clearTimeout(form._svTimer);
      if (msg) {
        msg.hidden = true;
        msg.textContent = '';
      }
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.remove('is-done');
      btn.classList.add('is-busy');
      if (label) label.textContent = 'Adding…';

      var request;
      try {
        request = S.cart.add([{ id: id, quantity: 1 }], { open: true });
      } catch (err) {
        request = Promise.reject(err);
      }

      Promise.resolve(request)
        .then(function () {
          btn.classList.remove('is-busy');
          btn.classList.add('is-done');
          if (label) label.textContent = 'Added';
          /* The drawer announces the add itself; only errors are voiced here. */
          form._svTimer = window.setTimeout(function () {
            btn.classList.remove('is-done');
            btn.removeAttribute('aria-disabled');
            if (label) label.textContent = 'Add to bag';
          }, 2200);
        })
        .catch(function (err) {
          var text = (err && (err.description || err.message)) || 'Couldn’t add this item. Please try again.';
          btn.classList.remove('is-busy');
          btn.removeAttribute('aria-disabled');
          if (label) label.textContent = 'Add to bag';
          if (msg) {
            msg.textContent = text;
            msg.hidden = false;
          }
          announce(root, text);
        });
    }

    function init(root) {
      if (!root || root._svRelated) return;
      root._svRelated = true;

      root.addEventListener('submit', function (event) {
        onSubmit(root, event);
      });

      if (root.hasAttribute('data-url')) schedule(root);
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll(SEL);
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
